import type { Aggregate, Row } from './types';

const headerFields = ['FISTIP', 'VERGI_DAHIL', 'KUR', 'GENEL_ISKONTO', 'NAKLIYE_TOPLAM'];
const lineFields = ['SATIR_TIP', 'GIRILEN_MIKTAR', 'KOLI_ICI', 'BF_DOVIZ', 'INDIRIM_ORAN', 'VERGI_ORAN', 'BIRIM_BRUT', 'GUMRUK_KG_BF', 'MALIYET_KILIT', 'TOPLAM_MALIYET'];
const outputFields = ['BF', 'MIKTAR', 'BF_VERGISIZ', 'BF_INDIRIMLI_VERGISIZ', 'INDIRIM_TUTAR', 'VERGI_TUTAR', 'TUTAR', 'TOPLAM', 'TOPLAM_DOVIZ', 'BRUT', 'GUMRUK_MALIYET_BF', 'NAKLIYE_MALIYET_BF', 'TOPLAM_MALIYET'];
const pick = (row: Row, fields: string[]): Row => Object.fromEntries(fields.filter(key => key in row).map(key => [key, row[key]]));

// The server remains authoritative. Text, selection and payment changes do not
// affect its calculator and must not repeat the complete financial request.
export function calculationRequest(document: Aggregate): string {
  return JSON.stringify({ header: pick(document.header, headerFields), lines: document.lines.map(line => pick(line, lineFields)), payment: {} });
}

// Never let an in-flight calculation overwrite a newer description or other input.
export function calculationOutput(lines: Row[]): Row[] {
  return lines.map(line => pick(line, outputFields));
}
